import {DriverStatusEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function driverStatusTagNameFilter(status: DriverStatusEnum): string {
  switch (status) {
    case DriverStatusEnum.Active: return i18n.t(LF.Active) as string;
    case DriverStatusEnum.Warning: return i18n.t(LF.AttentionRequired) as string;
    case DriverStatusEnum.New: return i18n.t(LF.New) as string;
    case DriverStatusEnum.Problem: return i18n.t(LF.Problem) as string;
    case DriverStatusEnum.Inactive: return i18n.t(LF.Inactive) as string;
    case DriverStatusEnum.WaitingForActivation: return i18n.t(LF.WaitingForAccountsActivation) as string;
    case DriverStatusEnum.NoSettlementsInLast2Weeks: return i18n.t(LF.NoSettlementsInLast2Weeks) as string;
    case DriverStatusEnum.Bailiff: return i18n.t(LF.Bailiff) as string;
    case DriverStatusEnum.Debtor: return i18n.t(LF.Debtor) as string;
    case DriverStatusEnum.PaymentSuspension: return i18n.t(LF.PaymentSuspension) as string;
    case DriverStatusEnum.Fraud: return i18n.t(LF.Fraud) as string;
    case DriverStatusEnum.OfficeVisitRequired: return i18n.t(LF.OfficeVisitRequired) as string;
    case DriverStatusEnum.Duplicate: return i18n.t(LF.Duplicate) as string;
    case DriverStatusEnum.FilesMissingAfterUserRegistration: return i18n.t(LF.MissingRequiredFilesAfterRegistration) as string;
    case DriverStatusEnum.HasMobileApplication: return i18n.t(LF.HasMobileApplication) as string;
  }
}
